export interface Movie {
  id: string;
  title: string;
  slug: string;
  poster: string;
  backdrop: string;
  year: number;
  category: string;
  categorySlug: string;
  genre: string[];
  rating: number;
  duration: string;
  region: string;
  description: string;
  director: string;
  cast: string[];
  isNew: boolean;
  isHot: boolean;
  isVip: boolean;
  updateInfo: string;
  tags: string[];
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-movie-line' },
  { name: '动作片', slug: 'action', icon: 'ri-sword-line' },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-happy-line' },
  { name: '爱情片', slug: 'romance', icon: 'ri-heart-line' },
  { name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line' },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line' },
  { name: '剧情片', slug: 'drama', icon: 'ri-film-line' },
  { name: '动画片', slug: 'animation', icon: 'ri-palette-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
  { name: '国产剧', slug: 'cn-drama', icon: 'ri-china-railway-line' },
  { name: '韩剧', slug: 'kr-drama', icon: 'ri-global-line' },
  { name: '美剧', slug: 'us-drama', icon: 'ri-flag-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-tv-line' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '流浪地球3',
    slug: 'wandering-earth-3',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20facing%20giant%20planet%20in%20deep%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20background%20with%20stars%2C%20clean%20minimal%20poster%20design%2C%20professional%20movie%20poster%20style%20with%20warm%20golden%20accents&width=600&height=800&seq=movie-poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20space%20scene%20with%20massive%20spaceship%20approaching%20a%20glowing%20planet%2C%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20sci-fi%20movie%20backdrop%2C%20deep%20space%20background%20with%20stars%20and%20nebula%2C%20dark%20and%20moody%20tone&width=1600&height=900&seq=movie-bg-01&orientation=landscape',
    year: 2025,
    category: '科幻片',
    categorySlug: 'scifi',
    genre: ['科幻', '冒险', '灾难'],
    rating: 8.6,
    duration: '148分钟',
    region: '中国大陆',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器寻找新家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。本片延续前作宏大叙事，视觉效果全面升级，呈现中国科幻电影的巅峰水准。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    isNew: true,
    isHot: true,
    isVip: false,
    updateInfo: '2025-07-28 更新至HD高清',
    tags: ['热门推荐', '国产科幻', 'IMAX'],
  },
  {
    id: '2',
    title: '封神第二部',
    slug: 'fengshen-part-2',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20warriors%20in%20ancient%20armor%20facing%20mythical%20beasts%2C%20dramatic%20composition%2C%20dark%20background%20with%20golden%20accents%2C%20cinematic%20movie%20poster%20design%2C%20epic%20fantasy%20style&width=600&height=800&seq=movie-poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20battlefield%20with%20thousands%20of%20warriors%20in%20armor%2C%20dramatic%20sky%20with%20dark%20clouds%2C%20cinematic%20lighting%2C%20epic%20fantasy%20war%20scene%2C%20mythological%20atmosphere%2C%20dark%20and%20moody%20tone&width=1600&height=900&seq=movie-bg-02&orientation=landscape',
    year: 2025,
    category: '动作片',
    categorySlug: 'action',
    genre: ['动作', '奇幻', '古装'],
    rating: 8.3,
    duration: '156分钟',
    region: '中国大陆',
    description: '殷商大军兵临西岐，姜子牙率领西岐军民奋起反抗。闻仲率魔家四将强势来袭，杨戬、哪吒等英雄各显神通，一场改变封神世界格局的惊天大战即将上演。恢宏的特效场面与深刻的人物命运交织，打造华语奇幻史诗新篇章。',
    director: '乌尔善',
    cast: ['费翔', '黄渤', '于适', '陈牧驰', '此沙'],
    isNew: true,
    isHot: true,
    isVip: false,
    updateInfo: '2025-07-25 更新至HD高清',
    tags: ['热门推荐', '华语巨制', '神话史诗'],
  },
  {
    id: '3',
    title: '唐人街探案4',
    slug: 'detective-chinatown-4',
    poster: 'https://readdy.ai/api/search-image?query=Comedy%20mystery%20movie%20poster%20with%20two%20detectives%20in%20London%20streets%20at%20night%2C%20neon%20lights%2C%20cinematic%20composition%2C%20dark%20background%2C%20professional%20movie%20poster%20style%20with%20warm%20tones%20and%20mystery%20vibe&width=600&height=800&seq=movie-poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=London%20city%20at%20night%20with%20Big%20Ben%20in%20background%2C%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20cinematic%20lighting%2C%20mystery%20atmosphere%2C%20dark%20and%20moody%20urban%20scene&width=1600&height=900&seq=movie-bg-03&orientation=landscape',
    year: 2025,
    category: '喜剧片',
    categorySlug: 'comedy',
    genre: ['喜剧', '悬疑', '动作'],
    rating: 7.9,
    duration: '135分钟',
    region: '中国大陆',
    description: '唐仁和秦风受邀前往伦敦参加世界侦探大赛，却发现了一场惊天阴谋。来自各国的顶级侦探齐聚一堂，一场跨越欧亚大陆的猫鼠游戏就此展开。笑料不断的同时，层层反转的剧情让人拍案叫绝。',
    director: '陈思诚',
    cast: ['王宝强', '刘昊然', '妻夫木聪', '托尼·贾'],
    isNew: false,
    isHot: true,
    isVip: false,
    updateInfo: '2025-07-20 更新至HD高清',
    tags: ['热门推荐', '喜剧悬疑', '系列电影'],
  },
  {
    id: '4',
    title: '深海危机',
    slug: 'deep-sea-crisis',
    poster: 'https://readdy.ai/api/search-image?query=Underwater%20disaster%20movie%20poster%20with%20submarine%20in%20dark%20ocean%20depths%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20blue%20background%20with%20bubbles%2C%20tense%20atmosphere%2C%20professional%20movie%20poster%20style&width=600&height=800&seq=movie-poster-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20abyss%20with%20submarine%20descending%20into%20darkness%2C%20dramatic%20underwater%20lighting%2C%20cinematic%20atmosphere%2C%20mysterious%20deep%20sea%20scene%2C%20dark%20and%20moody%20tone%2C%20bubbles%20and%20marine%20snow&width=1600&height=900&seq=movie-bg-04&orientation=landscape',
    year: 2025,
    category: '动作片',
    categorySlug: 'action',
    genre: ['动作', '灾难', '悬疑'],
    rating: 7.5,
    duration: '128分钟',
    region: '中国大陆',
    description: '一艘深海探测器在马里亚纳海沟神秘失联，一支精英救援队奉命前往营救。然而在万米深海之下，他们发现了一个足以改变人类历史的惊天秘密。面对未知的深海巨兽和时间的紧迫，救援队员们必须在极限环境中做出生死抉择。',
    director: '林超贤',
    cast: ['张译', '黄景瑜', '杜江', '海清'],
    isNew: true,
    isHot: false,
    isVip: false,
    updateInfo: '2025-07-22 更新至HD高清',
    tags: ['新片上线', '深海灾难', '国产大片'],
  },
  {
    id: '5',
    title: '长安三万里2',
    slug: 'chang-an-2',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20ancient%20Tang%20dynasty%20poets%20under%20moonlight%2C%20traditional%20Chinese%20painting%20style%2C%20dark%20background%20with%20golden%20accents%2C%20poetic%20atmosphere%2C%20artistic%20movie%20poster%20design&width=600&height=800&seq=movie-poster-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20of%20Changan%20at%20sunset%2C%20traditional%20architecture%2C%20poetic%20atmosphere%2C%20cinematic%20lighting%2C%20Tang%20dynasty%20scenery%2C%20warm%20golden%20sunlight%2C%20artistic%20rendering%20style&width=1600&height=900&seq=movie-bg-05&orientation=landscape',
    year: 2025,
    category: '动画片',
    categorySlug: 'animation',
    genre: ['动画', '历史', '传记'],
    rating: 8.8,
    duration: '168分钟',
    region: '中国大陆',
    description: '继前作讲述李白和高适的故事后，本片聚焦于杜甫跌宕起伏的一生。从年少轻狂到乱世飘零，从"会当凌绝顶"到"无边落木萧萧下"，诗圣杜甫用一生的苦难铸就了不朽的诗篇。画面延续前作精美画风，情感更加深沉动人。',
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全'],
    isNew: false,
    isHot: true,
    isVip: false,
    updateInfo: '2025-07-15 更新至HD高清',
    tags: ['热门推荐', '国漫之光', '历史传记'],
  },
  {
    id: '6',
    title: '暗夜追踪',
    slug: 'night-chase',
    poster: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20detective%20in%20rainy%20alley%20at%20night%2C%20neon%20reflections%2C%20noir%20style%2C%20dark%20background%2C%20tense%20atmosphere%2C%20cinematic%20poster%20design%20with%20dramatic%20shadows&width=600&height=800&seq=movie-poster-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20with%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20cinematic%20lighting%2C%20dark%20and%20moody%20urban%20scene%2C%20mysterious%20vibe&width=1600&height=900&seq=movie-bg-06&orientation=landscape',
    year: 2025,
    category: '剧情片',
    categorySlug: 'drama',
    genre: ['剧情', '悬疑', '犯罪'],
    rating: 8.1,
    duration: '118分钟',
    region: '中国香港',
    description: '一位退休刑警在深夜接到一通神秘电话，对方声称知道20年前一桩悬案的真相。随着调查深入，他发现这桩旧案牵连甚广，身边的每个人都可能是凶手。真相与谎言交织，人性在暗夜中显露无疑。',
    director: '郑保瑞',
    cast: ['古天乐', '林家栋', '刘青云', '任达华'],
    isNew: true,
    isHot: false,
    isVip: false,
    updateInfo: '2025-07-18 更新至HD高清',
    tags: ['新片上线', '港产犯罪', '悬疑佳作'],
  },
  {
    id: '7',
    title: '我们的浪漫时光',
    slug: 'our-romantic-time',
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20with%20couple%20walking%20on%20beach%20at%20sunset%2C%20warm%20golden%20lighting%2C%20soft%20atmosphere%2C%20cinematic%20composition%2C%20dark%20silhouette%20style%2C%20emotional%20and%20tender%20vibe&width=600&height=800&seq=movie-poster-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Beautiful%20sunset%20beach%20with%20golden%20light%20reflecting%20on%20gentle%20waves%2C%20warm%20atmosphere%2C%20romantic%20scene%2C%20cinematic%20lighting%2C%20soft%20and%20dreamy%20tone%2C%20peaceful%20ocean%20view&width=1600&height=900&seq=movie-bg-07&orientation=landscape',
    year: 2025,
    category: '爱情片',
    categorySlug: 'romance',
    genre: ['爱情', '剧情'],
    rating: 7.8,
    duration: '112分钟',
    region: '中国大陆',
    description: '两个在都市中打拼的年轻人，因为一次偶然的相遇而走进彼此的世界。从陌生到熟悉，从误解到理解，他们在平凡的日子里发现了不平凡的浪漫。一部温暖治愈的都市爱情故事，献给所有相信爱的人。',
    director: '薛晓路',
    cast: ['周冬雨', '刘昊然', '陈道明'],
    isNew: false,
    isHot: false,
    isVip: false,
    updateInfo: '2025-07-10 更新至HD高清',
    tags: ['爱情佳作', '治愈暖心'],
  },
  {
    id: '8',
    title: '咒怨：重生',
    slug: 'juon-rebirth',
    poster: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20with%20haunted%20Japanese%20house%20in%20darkness%2C%20creepy%20atmosphere%2C%20pale%20face%20emerging%20from%20shadows%2C%20dark%20and%20ominous%20tone%2C%20cinematic%20horror%20poster%20design%2C%20disturbing%20vibe&width=600&height=800&seq=movie-poster-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Dark%20abandoned%20Japanese%20house%20interior%20with%20faint%20moonlight%20through%20broken%20windows%2C%20creepy%20atmosphere%2C%20shadows%20and%20dust%20particles%2C%20horror%20movie%20scene%2C%20ominous%20and%20terrifying%20tone&width=1600&height=900&seq=movie-bg-08&orientation=landscape',
    year: 2025,
    category: '恐怖片',
    categorySlug: 'horror',
    genre: ['恐怖', '惊悚'],
    rating: 7.2,
    duration: '105分钟',
    region: '日本',
    description: '经典日式恐怖系列全新重启。一群大学生误入一栋荒废多年的凶宅，却不知道这里正是咒怨的起源之地。当他们试图逃离时，发现已经被无尽的怨念所包围。日式恐怖巅峰之作，让你彻夜难眠。',
    director: '清水崇',
    cast: ['山崎贤人', '滨边美波', '菅田将晖'],
    isNew: false,
    isHot: false,
    isVip: false,
    updateInfo: '2025-07-08 更新至HD高清',
    tags: ['日式恐怖', '经典重启'],
  },
  {
    id: '9',
    title: '狂飙人生',
    slug: 'racing-life',
    poster: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20sports%20cars%20racing%20on%20city%20streets%20at%20night%2C%20motion%20blur%2C%20neon%20lights%2C%20dark%20background%2C%20cinematic%20composition%2C%20adrenaline%20fueled%20style%2C%20dynamic%20racing%20vibe&width=600&height=800&seq=movie-poster-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Highway%20at%20night%20with%20fast%20sports%20cars%20racing%2C%20neon%20city%20lights%20in%20background%2C%20motion%20blur%20effect%2C%20cinematic%20lighting%2C%20dynamic%20and%20exciting%20scene%2C%20dark%20urban%20racing%20atmosphere&width=1600&height=900&seq=movie-bg-09&orientation=landscape',
    year: 2025,
    category: '动作片',
    categorySlug: 'action',
    genre: ['动作', '犯罪', '剧情'],
    rating: 8.0,
    duration: '132分钟',
    region: '中国香港',
    description: '一位退役赛车手为了给弟弟报仇，重新回到地下赛车世界。在这个由金钱、权力和速度主宰的黑暗王国中，他必须用性命去赌一个真相。港式飞车动作片全新力作，实拍特技令人血脉贲张。',
    director: '陈木胜',
    cast: ['谢霆锋', '刘德华', '古天乐'],
    isNew: false,
    isHot: false,
    isVip: false,
    updateInfo: '2025-07-05 更新至HD高清',
    tags: ['港产动作', '飞车特技'],
  },
  {
    id: '10',
    title: '舌尖上的中国：寻味',
    slug: 'bite-of-china-quest',
    poster: 'https://readdy.ai/api/search-image?query=Documentary%20poster%20with%20beautiful%20Chinese%20cuisine%20closeup%20on%20wooden%20table%2C%20steam%20rising%2C%20warm%20lighting%2C%20dark%20background%2C%20artistic%20food%20photography%20style%2C%20authentic%20Chinese%20cooking%20scene&width=600&height=800&seq=movie-poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20kitchen%20with%20steaming%20wok%20and%20fresh%20ingredients%2C%20warm%20lighting%2C%20authentic%20cooking%20scene%2C%20rustic%20atmosphere%2C%20cozy%20and%20inviting%20tone%2C%20culinary%20documentary%20style&width=1600&height=900&seq=movie-bg-10&orientation=landscape',
    year: 2025,
    category: '纪录片',
    categorySlug: 'documentary',
    genre: ['纪录片', '美食'],
    rating: 9.2,
    duration: '90分钟',
    region: '中国大陆',
    description: '《舌尖上的中国》系列全新纪录片，深入中国最偏远的乡村和城镇，寻找那些即将消失的传统美食和手艺。从云南深山的松茸到东北雪原的冻梨，每一道美食背后都是一个关于坚守和传承的故事。',
    director: '陈晓卿',
    cast: ['李立宏（旁白）'],
    isNew: true,
    isHot: false,
    isVip: false,
    updateInfo: '2025-07-12 更新至HD高清',
    tags: ['新片上线', '美食纪录', '高分佳作'],
  },
  {
    id: '11',
    title: '繁花似锦',
    slug: 'blossoms',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20poster%20with%20elegant%20woman%20in%20cheongsam%20in%201930s%20Shanghai%2C%20vintage%20style%2C%20dark%20background%20with%20golden%20accents%2C%20cinematic%20composition%2C%20period%20drama%20aesthetic&width=600&height=800&seq=movie-poster-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=1930s%20Shanghai%20bund%20at%20night%20with%20art%20deco%20buildings%2C%20vintage%20cars%2C%20neon%20signs%2C%20cinematic%20lighting%2C%20nostalgic%20atmosphere%2C%20dark%20and%20romantic%20tone&width=1600&height=900&seq=movie-bg-11&orientation=landscape',
    year: 2025,
    category: '国产剧',
    categorySlug: 'cn-drama',
    genre: ['剧情', '爱情', '年代'],
    rating: 8.5,
    duration: '40集',
    region: '中国大陆',
    description: '改编自金宇澄同名小说，以上世纪九十年代的上海为背景，讲述了阿宝、沪生、小毛三个不同阶层的年轻人在时代浪潮中的命运沉浮。一幅上海市井百态的宏大画卷，一部充满烟火气的城市史诗。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    isNew: false,
    isHot: true,
    isVip: false,
    updateInfo: '2025-07-26 更新至第38集',
    tags: ['热门推荐', '国产剧王', '年代大戏'],
  },
  {
    id: '12',
    title: '黑暗荣耀',
    slug: 'the-glory',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20elegant%20woman%20in%20dark%20suit%20with%20intense%20gaze%2C%20minimalist%20style%2C%20dark%20background%2C%20cinematic%20composition%2C%20revenge%20thriller%20vibe%2C%20professional%20drama%20poster%20design&width=600&height=800&seq=movie-poster-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Modern%20Seoul%20cityscape%20at%20night%20with%20rain%2C%20neon%20lights%20reflecting%20on%20streets%2C%20cinematic%20lighting%2C%20dark%20and%20moody%20atmosphere%2C%20urban%20Korean%20drama%20scene&width=1600&height=900&seq=movie-bg-12&orientation=landscape',
    year: 2025,
    category: '韩剧',
    categorySlug: 'kr-drama',
    genre: ['剧情', '复仇', '悬疑'],
    rating: 9.0,
    duration: '16集',
    region: '韩国',
    description: '文东恩在高中时期遭受了残酷的校园暴力后退学，多年后她成为了加害者孩子的班主任。一场精心策划的复仇大计就此展开，每一个曾经伤害过她的人都将付出代价。宋慧乔演技巅峰之作，引发全球追剧热潮。',
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '廉惠兰'],
    isNew: false,
    isHot: true,
    isVip: false,
    updateInfo: '2025-07-24 更新至第12集',
    tags: ['热门推荐', '韩剧神作', '复仇爽剧'],
  },
];

export const featuredMovieIds = ['1', '2', '5'];
export const hotMovieIds = ['1', '2', '3', '5', '11', '12'];
export const newMovieIds = ['1', '2', '4', '6', '10'];

export const bannerSlides = [
  {
    movieId: '1',
    subtitle: '中国科幻电影巅峰之作',
    ctaText: '立即观看',
  },
  {
    movieId: '2',
    subtitle: '华语神话史诗巨制',
    ctaText: '立即观看',
  },
  {
    movieId: '5',
    subtitle: '国漫之光 诗意再现',
    ctaText: '立即观看',
  },
];